export default "__VITE_ASSET__CqbLALQN__"